"use client";

import { useRouter } from "next/navigation";
import { MapPin } from "@/components/icons";
import { InlineCombobox } from "@/components/ui/inline-combobox";

export type PlaceOption = { href: string; name: string };

export function PlacePicker({
  options,
  currentHref,
}: {
  options: readonly PlaceOption[];
  currentHref: string;
}) {
  const router = useRouter();
  return (
    <div className="w-full sm:w-72">
      <InlineCombobox
        options={options.map((option) => ({
          value: option.href,
          label: option.name,
        }))}
        value={currentHref}
        placeholder="Choose a place"
        searchPlaceholder="Find a state or city"
        ariaLabel="Place"
        leadingIcon={<MapPin className="size-4" aria-hidden />}
        onSelect={(href) => router.push(href)}
      />
    </div>
  );
}
